// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"9abfa595","210":"a19082a4","244":"cd1a1518","394":"186a1be2","745":"1d5d3d59","812":"d4bb4701"}[chunkId] + ".css";
};